// import fetch from 'isomorphic-fetch'
import pako from 'pako';
import {BASE_URL} from '../urls';
import uuid from 'uuid';
import userPool from '../userPool';

export const LATEST_VERSION_ENDPOINT = `${BASE_URL}/qdd/latestVersion`;
export const QDD_ENDPOINT = `${BASE_URL}/qdd`;
export const RESPONSE_ENDPOINT = `${BASE_URL}/responses`;
export const TRANSLATION_ENDPOINT = `${BASE_URL}/updateTranslation`;

export const START_SYNC_PULL = 'START_SYNC_PULL';
export function startSyncPull() {
  return {
    type: START_SYNC_PULL
  };
}

export const SYNC_ERROR = 'SYNC_ERROR';
export function syncError(errorMsg) {
  return {
    type: SYNC_ERROR,
    msg: errorMsg
  };
}

export const SYNC_AUTH_ERROR = 'SYNC_AUTH_ERROR';
export function syncAuthError(errorMsg) {
  userPool.signOut();
  return {
    type: SYNC_AUTH_ERROR,
    error: errorMsg
  };
}

export const START_SYNC_CHECK = 'START_SYNC_CHECK';
export function startSyncCheck() {
  return {
    type: START_SYNC_CHECK
  }
}

export const HANDLE_NEW_QDD = 'HANDLE_NEW_QDD';
export function handleNewQDD(qdd) {
  return {
    type: HANDLE_NEW_QDD,
    payload: qdd
  };
}

export const START_SYNC_PUSH = 'START_SYNC_PUSH';
export function startSyncPush() {
  return {
    type: START_SYNC_PUSH
  };
}

export const SYNC_PUSH_FINISHED = 'SYNC_PUSH_FINISHED';
export function syncPushFinished(version) {
  return {
    type: SYNC_PUSH_FINISHED,
    version: version
  };
}

export const START_RESPONSE_PUSH = 'START_RESPONSE_PUSH';
export function startResponsePush(response) {
  return {
    type: START_RESPONSE_PUSH,
    response
  };
}

export const FINISHED_RESPONSE_PUSH = 'FINISHED_RESPONSE_PUSH';
export function finishedResponsePush(response, e) {
  return {
    type: FINISHED_RESPONSE_PUSH,
    response,
    error: e
  };
}

function needsSync(state) {
  return (new Date()).getTime() - state.lastSynced > 5000
}

function pull(url) {
  return (dispatch) => {
    dispatch(startSyncPull());
    return fetch(url)
      .then((response) => {
        return response.json()
          .then((json) => {
            if (json.compressed) {
              let unencodedString = atob(json.compressed);
              let deflatedStringStore = pako.inflate(unencodedString, {to: 'string'});
              json = JSON.parse(deflatedStringStore);
              //BJS TODO: remove once saving persists
              //json.translationList = [] // [{id: 2, title:"Spanish", published: false, updatedAt: (new Date()).getTime()}, {id:3, title:"French", published: false, updatedAt: (new Date()).getTime()}];
            }
            dispatch(handleNewQDD(json));
            Promise.resolve();
          });
      });
  }
}

export function pushLocalState() {
  return (dispatch, getState) => {
    let state = getState();
    if (!state.auth.token) {
      throw new Error("Push started without credentials");
    }
    dispatch(startSyncPush());
    let store = {
      targets: state.options,
      questions: state.questions,
      categories: state.categories,
      version: state.sync.version + 2,
      tags: state.tags,
      translationList: state.translationList
    }
    let stringStore = JSON.stringify(store);
    let deflated = pako.deflate(stringStore, {to: 'string'});
    let encoded = btoa(deflated);
    return fetch(QDD_ENDPOINT, {
      method: 'POST',
      compress: false,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': state.auth.token
      },
      body: JSON.stringify({
        compressed: encoded,
        version: store.version
      })
    })
    .then((res) => {
      if (!res.ok) {
        if (res.status === 401 || res.status === 403) {
          dispatch(syncAuthError("Your session has expired"));
        } else {
          throw new Error("Problem saving response");
        }
      } else {
        res.json().then((response) => {
          dispatch(syncPushFinished(response.version));
          Promise.resolve();
        })
      }
    })
    .catch((e) => {
      console.log(e);
      // dispatch(syncError("Error pushing local changes"));
    });
  }
}

export function pushTranslation(trID, isNew) {
  return (dispatch, getState) => {
    let state = getState();
    if (!state.auth.token) {
      throw new Error("Push started without credentials");
    }
    let translation = state.translations.find(t => t.id === trID)
    let stringStore = JSON.stringify(translation);
    let deflated = pako.deflate(stringStore, {to: 'string'});
    let encoded = btoa(deflated);
    return fetch(TRANSLATION_ENDPOINT, {
      method: isNew ? 'POST' : 'PUT',
      compress: false,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': state.auth.token
      },
      body: JSON.stringify({
        compressed: encoded,
        version: translation.id
      })
    })
    .then((res) => {
      if (!res.ok) {
        if (res.status === 401 || res.status === 403) {
          dispatch(syncAuthError("Your session has expired"));
        } else {
          throw new Error("Problem saving response");
        }
      } else {
        res.json().then((response) => {
          Promise.resolve();
        })
      }
    })
    .catch((e) => {
      console.log(e);
    });
  }
}

export function pushIfNeeded() {
  return (dispatch, getState) => {
    let state = getState();
    if (state.sync.localChanges && !state.sync.isSyncing) {
      dispatch(pushLocalState());
    }
  }
}

export function putResponse(response, callback) {
  return (dispatch, getState) => {
    let state = getState();
    if (typeof response === 'string') {
      response = state.responses.items.find((r) => r.metadata.id === response);
    }
    if (response.email !== state.auth.email && !state.auth.isAdmin) {
      var e = new Error("Cannot sync other user's data");
      if (callback) callback("Cannot sync other user's data")
      throw e;
    }
    dispatch(startResponsePush(response));
    let url = RESPONSE_ENDPOINT + "/";
    let post = !response.metadata.created
    if (!post) {
      url += response.metadata.id;
    }
    return fetch(url, {
      method: post ? 'POST' : 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': state.auth.token
      },
      body: JSON.stringify(response)
    })
    .then((res) => {
      if (!res.ok) {
        if (res.status === 401 || res.status === 403) {
          dispatch(syncAuthError("Your session has expired"));
          if (callback) callback("Your user session has expired")
        } else {
          throw new Error("Problem saving response. Network issue.");
        }
      } else {
        dispatch(finishedResponsePush(response));
        if (callback) callback(null);
        Promise.resolve();
      }
    })
    .catch((e) => {
      console.error(e)
      dispatch(syncError("Problem saving response"));
      dispatch(finishedResponsePush(response, e));
      if (callback) callback(e.toString());
    });
  }
}

export function pushResponseIfNeeded() {
  return (dispatch, getState) => {
    let state = getState();
    if (state.sync.localquestionnaireChanges) {
      for (var response of state.responses.items) {
        if (response.email === state.auth.email && !response.metadata.pushing) {
          if (!response.metadata.lastSynced || (response.metadata.lastSynced && response.metadata.lastSynced < response.metadata.editedAt)) {
            dispatch(putResponse(response));
          }
        }
      }
    }
  }
}

function compareRemoteVersion(localVersion) {
  return fetch(LATEST_VERSION_ENDPOINT)
    .then((response) => {
      return response.json()
        .then((json) => {
          if (!json.version) {
            throw new Error("Server response did not include version");
          }
          if (json.version > localVersion) {
            return json.url;
          } else {
            return false;
          }
        });
    });
}

export function pullIfNeeded() {
  return (dispatch, getState) => {
    // dispatch(startSyncCheck());
    let state = getState();
    if (needsSync(state.sync)) {
      return compareRemoteVersion(state.sync.version)
        .then((newVersion) => {
          if (newVersion) {
            return dispatch(pull(newVersion));
          } else {
            return Promise.resolve();
          }
        }).catch((e) => {
          console.log(e);
          dispatch(syncError("Problem getting remote version"));
        });
    } else {
      return Promise.resolve();
    }
  }
}

export const FINISHED_RESPONSE_FETCH = 'FINISHED_RESPONSE_FETCH';
export function finishedResponseFetch(response) {
  return {
    type: FINISHED_RESPONSE_FETCH,
    payload: response
  };
}

export const RESPONSE_FETCH_ERROR = 'RESPONSE_FETCH_ERROR';
export function responseFetchError(msg) {
  return {
    type: RESPONSE_FETCH_ERROR,
    msg: msg
  };
}

export const RESPONSE_FETCH_STARTED = 'RESPONSE_FETCH_STARTED';
export function responseFetchStarted() {
  return {
    type: RESPONSE_FETCH_STARTED
  };
}

export function fetchAndLoadResponse(id, secretKey) {
  return (dispatch, getState) => {
    dispatch(responseFetchStarted());
    return fetch(`${RESPONSE_ENDPOINT}/${id}`)
      .then((response) => {
        return response.json()
          .then((json) => {
            if (!json.metadata) {
              throw new Error(`Server could not find response with id ${id}:${secretKey}`);
            } else {
              json.metadata.secretKey = secretKey;
              dispatch(finishedResponseFetch(json));
            }
          });
      }).catch((e) => {
        console.log(e);
        dispatch(responseFetchError(e.toString()));
      });
  }
}

const IMAGE_UPLOAD_ENDPOINT = `${BASE_URL}/images`;

export function uploadImage(file) {
  return (dispatch, getStore) => {
    window.file = file;
    let token = getStore().auth.token;
    let parts = file.name.split(".");
    let filename = `${uuid.v4()}.${parts[parts.length - 1]}`;
    let reader = new FileReader();
    return new Promise((resolve, reject) => {
      reader.onloadend = function(){
        fetch(`${IMAGE_UPLOAD_ENDPOINT}/${filename}`, {
          method: 'POST',
          headers: {
            'Authorization': token,
            'Content-Type': file.type
          },
          body: btoa(reader.result)
        }).then((response) => {
          resolve({
            data: {
              link: `https://s3-us-west-2.amazonaws.com/fishpath-images/${filename}`
            }
          });
        }).catch(reject);
      }
      reader.readAsBinaryString(file);
    });
  }
}
